import './custom_highchart.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.CustomProfileContentHistoryChart extends Monitoring.Views.Charts.CustomHighchart
  url: '/monitoring/dashboard/charts/tpm'

  initialize: (@options = {}) ->
    super(@options)
    @_customOptions = @options.customOptions || {}

  series: ->
    @data.series
    # [{
    #     name: 'UGC'
    #     color: '#3090C7' # Blue Ivy
    #     data: [[1449619200000, 1], [1450224000000, 3], [1450656000000, 3], [1450742400000, 1], [1453161600000, 3], [1453334400000, 7], [1453420800000, 5], [1454371200000, 3], [1455062400000, 3]]
    # }]

  customOptions: ->
    options = {
      chart:
        marginTop: 20
        #marginBottom: 0
        type: 'area'
      legend:
        enabled: false
      title:
        text: null
      xAxis:
        type: 'datetime'
        allowDecimals: false,
      yAxis:
        title:
          text: null
      tooltip:
        followPointer: true
        positioner: (labelWidth, labelHeight, point) ->
          chart = this.chart
          pointX = if (point.plotX + labelWidth > chart.plotWidth) then point.plotX + chart.plotLeft - labelWidth - 10 else point.plotX + chart.plotLeft + 10
          x = if pointX > 0 then pointX else 0
          y = if point.plotY + chart.plotTop - 20 > 35 then point.plotY + chart.plotTop - 20 else 35
          return { x: x , y: y }
        pointFormat: '{series.name} count: <b>{point.y:,.0f}</b><br/>'
      plotOptions:
        area:
          marker:
            enabled: false
            symbol: 'circle'
            radius: 2
            states:
              hover:
                enabled: true
      exporting:
        enabled: false
    }
    $.extend(true, options, @_customOptions)
    return options

  getSearchQuery: ->
    @searchQuery.set('date_from', "1 Jul 2016 04:00")
    @searchQuery.set('date_from_ISO', "2016-07-01T04:00:00.000Z")
    @searchQuery.deepCopy()
